import { useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "./../../common/commonUtil";
import messageConst from "../../const/messageConst";
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import "../../resources/css/common/calendar.css";
import cross from '../../resources/icons/ico_X.svg';
import circle from '../../resources/icons/ico_circle.svg';
import square from '../../resources/icons/ico_square.svg';
import triangle from '../../resources/icons/ico_triangle.svg';
import { Image } from "../atoms/image";
import { Label } from '../atoms/label';
import { ModalClose } from "../atoms/modalClose";
import './../../resources/css/popup/golf_facility_calendar_popup.css';
import common from "../../resources/js/common/common"
import { searchResultApi } from "../../const/";
const GolfFacilityCalendarContainer = (props) => {
    const { state,
        setMembershipSearchParam,
        onClickCalendarMove,
        onClickCloseFacilityCalendarWindow,
        playDate1,
        group,
        course,
        startTime,
        login,
        kaiinken,
        addTeeTimeList,
        setReserveCheckInfo,
        setChangeReserveNo,
        setCourse,
        setPlayDate1,
        setSearchResult} = props;

    // 祝日取得用カスタムフック
    const { getHoliday } = GetPublicHoliday();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [activeStartDate, setActiveStartDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const firstDate = useRef(null);
    const count = useRef(0);
    const popupFlg = state.facilityCalendarPopup;
    const calendarStartDate = state.calendarStartDate;
    const courseId = useRef(null);
    const dataList = state.facilityVacancyInfo.vacancyDateList;
    const facilityTel = state.facilityVacancyInfo.facilityTel;
    const store = useStore();
    const history = useHistory();
    const [latestFlg, setLatestFlg] = useState(false);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);


    useEffect(() => {
        // 次へ表示ボタンに関数登録
        const nextElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__next-button");
        nextElm[1].addEventListener("click", nextDate);

        // 戻る表示ボタンに関数登録
        const prevElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__prev-button");
        prevElm[1].addEventListener("click", prevDate);
    },[])

    // プレー日欄に表示する日付取得(ポップアップレンダリング時)
    useEffect(() => {
        if (popupFlg) {
            document.getElementById("calendarDecision").disabled = false;
        }

        // カレンダー表示起点日
        let startDate = new Date();

        let selectDate = new Date();
        selectDate.setDate(selectDate.getDate() + 3);

        if (calendarStartDate) {
            // カレンダーの開始日付が指定されていた場合
            // カレンダー選択項目
            startDate = calendarStartDate;
            setActiveStartDate(calendarStartDate);
        } else if (store.getState().playDate1) {
            //storeにdateが入っていればそちらを使う
            let checkIn = new Date(store.getState().playDate1);
            startDate = checkIn;
            // カレンダー選択項目
            setActiveStartDate(checkIn);
        } else {
            // カレンダー選択項目
            setActiveStartDate(selectDate);
        }

        let now = new Date();
        let d1Month = startDate.getFullYear() * 12 + startDate.getMonth();
        let d2Month = now.getFullYear() * 12 + now.getMonth();
        let diffMonth = d1Month - d2Month;
        count.current = diffMonth;

        // カレンダー最大選択範囲
        let maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        setMaxDate(maxDate);

        // カレンダー最小選択範囲
        let minDate = new Date();
        minDate.setDate((minDate.getDate()+3));
        setMinDate(minDate);

        let first = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
        firstDate.current = first;

        courseId.current = state.courseId;
    }, [popupFlg]);

    // 次へ表示制御
    const nextDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current += 1;
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        let startDate
        const current =  firstDate.current
        if(current >= date){
            startDate = new Date(current);
        } else {
            // チェックイン
            startDate = new Date(date);
        }

        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        let groupNumber = 1;
        store.getState().group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        const startTimeArray = [];
        store.getState().startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });
        const startTimeStr =  startTimeArray.join();

        // const courseArray = [];
        // courseArray.push(courseId.current);

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        store.getState().kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                store.getState().course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const req = {
            startDate: `${y}-${m}-${d}`, 
            teeTime: startTimeStr, 
            partyCount: groupNumber,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
            courseId: [courseId.current],
            syoriKbn:"1"
        }
        onClickCalendarMove(req);
    }

    // 戻る表示制御
    const prevDate = () => {
        let activeDate = new Date();
        activeDate.setDate(1);
        count.current -= 1;
        if (count.current < 0) {
            count.current = 0;
            return;
        }
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        let date = new Date();
        date.setDate(25);
        date.setMonth(date.getMonth() + count.current - 1);

        // チェックイン
        let startDate;
        const current =  firstDate.current
        if(current >= date){
            startDate = new Date(current);
        } else {
            // チェックイン
            startDate = new Date(date);
        }

        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        let groupNumber = 1;
        store.getState().group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        const startTimeArray = [];
        store.getState().startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });
        const startTimeStr =  startTimeArray.join();

        // const courseArray = [];
        // courseArray.push(courseId.current);

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        store.getState().kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                store.getState().course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const req = {
            startDate: `${y}-${m}-${d}`, 
            teeTime: startTimeStr, 
            partyCount: groupNumber,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
            courseId: [courseId.current],
            syoriKbn:"1"
        }
        onClickCalendarMove(req);
    }

    // 表示する日付取得
    const onClickTargetDay = (val, event) => {
        
        // チェックイン
        const checkInDate = new Date(val);
        const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");
        const today = commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd");
        const within3 = commonUtil.getNights(today, startDate, "-");
        if (within3 < 3) {
            setLatestFlg(true);
        } else {
            setLatestFlg(false);
            
            // 「満室」「クローズ」「予約受付対象外」は遷移させない
            if (!dataList) return
            const targetDate = commonUtil.getStringFromDate(new Date(val), "yyyy-MM-dd");
            const vacancyMark = dataList.find(value => {
              if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") === targetDate) {
                return value.kushitsuMark
              }
            }).kushitsuMark
            console.log(vacancyMark);
            if (vacancyMark !== undefined && vacancyMark !== 1 && vacancyMark !== 2 && vacancyMark !== 4 ) {
              return
            }

            addTeeTimeList([]);
            setReserveCheckInfo([]);
            setChangeReserveNo("");
            for (let i in course) {
                if (course[i].id === courseId.current) {
                    course[i].checked = true;
                } else {
                    course[i].checked = false;
                }
            }
            setCourse(course);
            setPlayDate1(new Date(val));

            let y = new Date(val).getFullYear();
            let m = new Date(val).getMonth() + 1;
            let d = new Date(val).getDate();

            if (m < 10) m = `0${m}`
            if (d < 10) d = `0${d}`

            const startTimeArray = [];
            startTime.forEach((data) => {
                if (data.checked === true) startTimeArray.push(data.id);
            });

            let groupNumber = 1;
            group.forEach((data) => {
                if (data.selected === true) groupNumber = parseInt(data.id); 
            });

            let useMemberShipAuth;
            let kaiinKind;
            let courseArrayKaiinken;
            kaiinken.forEach((data) => {
                if (data.selected === true) {
                    courseArrayKaiinken = data.sisetuCd;
                    kaiinKind = data.kaiinkenSyubetCd;
                    course.forEach((courseData) => {
                        if(courseData.id === data.facilityCd){
                            useMemberShipAuth = courseData.memberShipAuth
                        }
                    })
                }
            });

            // リクエスト情報設定
            const req = {
                playDate: `${y}-${m}-${d}`,
                partyCount: groupNumber,
                courseId: [courseId.current],
                playStyle: [],
                teeTime: startTimeArray,
                days: '1',
                membershipAuthID:useMemberShipAuth,
                userFacility: courseArrayKaiinken,
                kaiinKind:kaiinKind,
            };
            console.log("カレンダー検索APIリクエスト");
            console.log(req);

            common.doPost(searchResultApi, req, afterToList);
        }
    };

    // 〇△押下後処理
    const afterToList = (res) => {
        const data = res.data;
        if (data.golfCourses === undefined) {
            // 取得エラー処理
            // setNotSearch(true);
            common.scrollWindow("condition");
            return;
        }
        const result = course.map((item) => {
            for (let i = 0; i < data.golfCourses.length; i++) {
                if (data.golfCourses[i].name === item.value) {
                    const resData = data.golfCourses[i];
                    const fac = {
                        courseid: item.courseid,
                        zip: item.zip,
                        address: item.address,
                        access_car: item.access_car,
                        facility_overview_title: item.facility_overview_title,
                        facility_overview_detail: item.facility_overview_detail,
                        url: item.url,
                        image_path: item.image_path,
                    }
                    Object.assign(resData, fac);
                    return resData;
                }
            }
            return null;
        });
        const re = result.filter(item => item != null);

        const resultData = {
            golfCourses: re
        }

        setSearchResult(resultData);

        // 画面遷移
        history.push("/reserve/golf/searchResult");
    }

    // カレンダーの月表示を大きくするための関数(スマホ版)
    const layoutChangeOfMonthMobile = (date) => {

        const label = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[1];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (label) {
            label.style.width = "100%";
            label.style.padding = "0";
            label.innerHTML = `${y}年<span class='month-view'> ${m}月</span>`;
        }
    };

    // 決定ボタン押下時
    const decision = () => {
        // 二度押し防止
        document.getElementById("calendarDecision").disabled = true;
    };

    const onClickClose = () => {
        // ポップアップの表示・非表示用更新関数
        onClickCloseFacilityCalendarWindow();
    }

    //日付の内容を出力
    const getTileContent = (calendar) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(calendar.date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        if (dataList) {
            dataList.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.kushitsuMark;
                }
            })
        }

        // タイルに表示する内容を返却
        return (
            <div style={{ height: "30%" }}>
                <Label
                    style={
                        vacancy === 1 ? (
                            style.circle
                        ) : (vacancy === 2 ? (
                            style.triangle
                        ) : (vacancy === 4 ? (
                            style.square
                        ) : (vacancy === 3 ? (
                            style.cross
                        ) : (
                            style.occupy
                        ))))
                    }
                />
            </div>
        );
    }

    const getbackGroundColor = (activeStartDate, date, view) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        let right = "";
        if (dataList) {
            dataList.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.kushitsuMark;
                }
            })
        }

        // タイル背景を返却
        let backGroundColor = "";
        backGroundColor = vacancy === 1 || vacancy === 2 || vacancy === 4  ?
            "white" : "right_none";
        return (getHoliday(activeStartDate, date, view) + " " + backGroundColor);
    }

    const closeLatestModal = () => {
        setLatestFlg(false);
    }

    return (
        <>
            <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
                <div className="popupInner">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClose} />
                    <div className="popupInnerText" >
                        <h4 className="popupInnerFacility" >
                            {state.popupTitle}
                        </h4>
                    </div>
                    {isMobilePhone ?
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate}
                            minDate={minDate}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        ) :
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate}
                            minDate={minDate}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        )}
                    <div style={isMobilePhone ? style.descriptionAreaMobile : style.descriptionArea}>
                        <div style={isMobilePhone ? { textAlign: "left", display: "flex", marginTop: "6rem", marginLeft: "10px", flexWrap: "wrap", whiteSpace: "nowrap" }
                            : { textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px", whiteSpace: "nowrap" }}>
                            <div style={style.tableImageStyle}>
                                <Image image={circle} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":空きあり"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={triangle} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":残りわずか"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={square} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":キャンセル待ち"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={cross} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":空きなし :対象外日"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", color: "rgb(173, 173, 173)" }}>
                            <Label label={"※本日・明日・明後日のご予約はお電話にてご連絡ください"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                    </div>
                </div>
                <div className="blackBackground" id="js-black-bg"></div>
            </div >
            <div className={latestFlg ? "golf_latest3Popup" : "popup"} id="js-popup">
                <div className="golf_latest3PopupInner">
                    <Label label={messageConst.WITHIN_3_DATE_MESSAGE} className="golf_latest3Label" />
                    <Label label={facilityTel} className="golf_latest3TelLabel" />
                    <button id="calendarDecision" className="golfCloseLatestModalBtn" onClick={closeLatestModal}>閉じる</button>
                </div>
                <div className="golf_latest3PopupblackBackground" id="js-black-bg"></div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login:state.login,
        kaiinken:state.kaiinken,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setChangeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GolfFacilityCalendarContainer);

const style = {
    svg: {
        height: "20",
        width: "20",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 40px 0",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15x 0 15px 0",
    },
    descriptionArea: {
        width: "90%",
        textAlign: "center",
        padding: "10px 5% 10px 5%",
    },
    descriptionAreaMobile: {
        width: "100%",
        textAlign: "center",
        padding: "0 0 0 0",
    },
    button: {
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    },
    tableImageStyle: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
    },

    imageStyle: {
        width: "11px",
        margin: "auto",
    },
    imageStyleMobile: {
        width: "11px",
        margin: "auto",
    },
    usageGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",
    },
    usageGuideColor: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0",
    },
    usageGuideColorMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0",
    },
    rightGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    rightGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    circle: {
        backgroundImage: `url(${circle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
        padding: "10px 0px 0px 0px",
    },
    triangle: {
        backgroundImage: `url(${triangle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    square: {
        backgroundImage: `url(${square})`,
        height: 10,
        width: 13,
        margin: "0 auto",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    cross: {
        backgroundImage: `url(${cross})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    occupy: {
        height: "auto",
        border: "0px",
        display: "block",
        opacity: "0.5",
        color: "black",
        fontSize: "1px",
    },
}
